import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	isOnline: false, // Is device online.
  caching: false, // App is currently fetching and caching data.
  ssaLastCached: new Date(0).toISOString(), // When SSA features data was last cached.
  weatherLastCached: new Date(0).toISOString(), // When weather info data was last cached.
  burnsLastCached: new Date(0).toISOString(), // When prescribed burns data was last cached.
  errorVisible: null
}

export const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    setOnline: (state, action) => {
	    state.isOnline = action.payload
    },
    updateSSALastCached: (state, action) => {
	    state.ssaLastCached = (new Date()).toISOString();
    },
    updateWeatherLastCached: (state, action) => {
	    state.weatherLastCached = (new Date()).toISOString();
    },
    updateBurnsLastCached: (state, action) => {
	    state.burnsLastCached = (new Date()).toISOString();
    },
    setBurnDataStale: (state, action) => {
	    state.burnsLastCached = (new Date(0)).toISOString();
    },
    setCaching: (state, action) => {
	    state.caching = action.payload
    },
    setErrorVisible: (state, action) => {
	    state.errorVisible = action.payload
    }
  },
})

export const { 
  setOnline,
  updateSSALastCached, 
  updateWeatherLastCached,
  updateBurnsLastCached,
  setBurnDataStale,
  setCaching,
  setErrorVisible
} = cacheSlice.actions

export default cacheSlice.reducer